import { render, staticRenderFns } from "./MyLicenseClaim.vue?vue&type=template&id=02ff545a&scoped=true&"
import script from "./MyLicenseClaim.vue?vue&type=script&lang=js&"
export * from "./MyLicenseClaim.vue?vue&type=script&lang=js&"
import style0 from "./MyLicenseClaim.vue?vue&type=style&index=0&id=02ff545a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ff545a",
  null
  
)

export default component.exports